<script>
  import Grid from './grid'

  export default Grid('flex')
</script>

<style lang="stylus" src="../../stylus/components/_grid.styl"></style>



// WEBPACK FOOTER //
// src/components/VGrid/VFlex.vue?32c841b2